import { atom } from 'recoil';

export const PromoCodeLoading = atom<boolean>({
  key: 'promo-code-loading',
  default: false,
});
